import { useTrans } from '../../../hooks'
import { Accordion } from '../../atoms'
import { Check } from '../../icons'
import styles from './OrderByAccordion.module.sass'

interface Props {
  ordinamenti: any[]
  orderBy: string
  setOrderBy: (orderBy: string) => void
  className?: string
}

const OrderByAccordion = (props: Props) => {
  const { ordinamenti = [], orderBy = undefined, setOrderBy = undefined, className = '' } = props

  const t = useTrans()

  return ordinamenti?.length ? (
    <Accordion
      id="order-by"
      label={t(`Ordina per: `)}
      variant="filter"
      className={`${styles.root} ${className}`}
    >
      <div className={styles.main}>
        {ordinamenti.length > 0 &&
          ordinamenti.map((item) => (
            <button
              onClick={() => setOrderBy(item.value)}
              className={`${styles.value} ${item.value === orderBy ? styles['value--active'] : ''}`}
              key={item.value}
            >
              <span>{item?.label}</span>
              {item.value === orderBy && <Check />}
            </button>
          ))}
      </div>
    </Accordion>
  ) : (
    <></>
  )
}

export default OrderByAccordion
